import { render, staticRenderFns } from "./Autoplay.vue?vue&type=template&id=4ab883ce&"
import script from "./Autoplay.vue?vue&type=script&lang=js&"
export * from "./Autoplay.vue?vue&type=script&lang=js&"
import style0 from "./Autoplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports